export default {
  lang(state) {
    return state.lang;
  },

  default_lang(state) {
    return state.default_lang;
  },
};
